module.exports = __webpack_public_path__ + "img/avatar.d3e3a516.jpg";